<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-interactive-report-dialog-form">
    <mat-form-field>
      <mat-label>Interactive</mat-label>
      <mat-select name="data.interactId" [(ngModel)]="data.interactId">
        <mat-option
          *ngFor="let interact of data.interacts"
          [value]="interact.interactId"
          >{{ interact.interactName }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input
        matInput
        name="data.name"
        [(ngModel)]="data.name"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>PowerBI Report Page Prefix</mat-label>
      <input
        matInput
        name="data.powerBIPrefix"
        [(ngModel)]="data.powerBIPrefix"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Display Rank</mat-label>
      <input
        matInput
        type="number"
        name="data.displayRank"
        [(ngModel)]="data.displayRank"
      /> </mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Interactive Report
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
